<template>
<div>
<v-btn absolute dark fab top right color="primary" style="top:10px;" @click="hubDialog = true">
    <v-icon color="black">add</v-icon>
</v-btn>
<hubForm :dialog="hubDialog" @setDialog="hubDialog = $event"
:editedIndex="editedIndex" @setEditIndex="editedIndex = $event"/>
<v-data-table :headers="headers" :items="users" :pagination.sync="pagination">
    <template slot="items" slot-scope="props">
    <td class="text-xs-center">{{ props.item.user_name }}</td>
    <td class="text-xs-center">{{ props.item.area }}</td>
    <td class="text-xs-center">{{ props.item.name }}</td>
    <td class="text-xs-center">{{ props.item.email }}</td>
    <td class="text-xs-center">{{ props.item.tel }}</td>
    <td class="text-xs-center">{{ props.item.status }}</td>
    <td class="justify-center layout px-0">
        <v-tooltip top>
            <v-btn icon @click="editHub()" slot="activator">
            <v-icon small>
            edit
            </v-icon>
            </v-btn>
            <span>Edit</span>
        </v-tooltip>
        <v-tooltip top>
            <v-btn icon slot="activator">
            <v-icon small>
            delete
            </v-icon>
            </v-btn>
            <span>Delete</span>
        </v-tooltip>
        <v-switch color="primary" class="head_status_toggle"></v-switch>
    </td>
</template>

<template slot="no-data">
    <v-btn color="primary" @click="initialize">Reset</v-btn>
</template>

</v-data-table>

 <!-- <div class="text-xs-center py-2">
      <v-pagination circle v-model="pagination.page" :length="pages"></v-pagination>
</div> -->
  </div>
</template>

<script>
import hubForm from './HubForm'
    export default {
        data: () => ({
            hubDialog : false,
            dialog: false,
            editedIndex: -1,
            pagination: {
                rowsPerPage:10
            },
            headers: [
                {
                    text: 'User name',
                    align: 'center',
                    sortable: false,
                    value: 'user_name'
                },
                {
                    text: 'Area',
                    align: 'center',
                    value: 'area',
                    sortable: false,
                },
                {
                    text: 'Name',
                    align: 'center',
                    value: 'name',
                    sortable: false,
                },
                {
                    text: 'Email',
                    align: 'center',
                    value: 'email',
                    sortable: false,
                },
                {
                    text: 'Tel.',
                    align: 'center',
                    value: 'tel',
                    sortable: false,
                },
                {
                    text: 'Status',
                    align: 'center',
                    value: 'status',
                    sortable: false,
                },
                {
                    text: 'Actions',
                    align: 'center',
                    value: 'actions',
                    sortable: false
                }
            ]
           
        }),
        components:{
            hubForm
        },
        computed: {
            pages () {
                if (this.pagination.rowsPerPage == null ||
                this.pagination.totalItems == null
                ) return 0

                return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
            }
        },
    
        watch: {
            dialog(val) {
                val || this.close()
            }
        },
    
        created() {
            this.initialize()
        },
    
        methods: {
            initialize() {
                this.users = [{
                        user_name: 'nynkbaz',
                        area: 'Phuket',
                        name: 'Nynk Krittapohn',
                        email: 'kk@phuket.com',
                        tel: '+66894631103',
                        status: 'Active',
                        action: ''
                    }
                ]
            },
            editHub() {
            this.hubDialog = true;
            this.editedIndex = 1;
            }
        }
    }
</script>

<style scoped>
.head_status_toggle {
     /* position:absolute; */
     margin-top:11px;
     max-width:50px;
     /* left:39%; */
}
</style>
